export const PAGINATION_DEFAULT = {
  limit: 50,
  offset: 0,
};
